module.exports = __webpack_public_path__ + "img/dbf.7a42ee3f.svg";